import React, { Component } from "react";
import { connect } from "react-redux";
import { usrRole } from "../../utils/dataUtil";
import {
  req_list_cslc_workstojury,
  req_downloadfile_cslc_myparticipant,
} from "../../api";
import { DEFAULT_IMAGE_URL, API_BASE } from "../../utils/contrains";
import { Button, Input, Image, Collapse, BackTop, Modal } from "antd";
import "./jury-all-works-list.css";
import OutFileModal from "./out-file-modal";
import PrintFileModal from "./print-file-modal";
const { Panel } = Collapse;

class JuryAllWorksList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    uploadStatus: "FINISH",
    choiceStatus: "",
    enrollCode: "",
    isPdfWorkModal: false,
    isPrintWorkModal: false,
  };

  componentDidMount() {
    this.api_list_items();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { token, userCode, role } = this.props.user;
    const { uploadStatus, choiceStatus, enrollCode } = this.state;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_list_cslc_workstojury(
      userLevel,
      userCode,
      uploadStatus,
      choiceStatus,
      enrollCode,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { data } = result;
      const items = data;

      this.setState({ items });
      // console.log(items);
    } else {
      const items = [];
      this.setState({ items });
    }
  };

  api_downloadfile_items = async () => {
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    const fileUrl = await req_downloadfile_cslc_myparticipant(
      userLevel,
      userCode,
      "",
      "",
      "",
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "參加人員清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_list_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "VIEW":
        this.setState({ isPdfWorkModal: true, item });
        break;
      case "PRINT":
        this.setState({ isPrintWorkModal: true, item });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  imgToBase64 = (name) => {
    const img = document.getElementById(name);
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      var canvas = document.createElement;
      var ctx = canvas.getContext("2D");
      canvas.height = this.naturalHeight;
      canvas.width = this.width;
      ctx.drawImage(this, 0, 0);
      var data = canvas.toDataURL("image/jpeg");
      console.log("data", data);
    };
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      enrollCode,
      loading,
      item,
      items,
      isPdfWorkModal,
      isPrintWorkModal,
    } = this.state;
    return (
      <>
        <div style={{ marginBottom: "4px" }}>
          <Input
            placeholder="學號"
            style={{
              width: 100,
              margin: "0 5px",
              backgroundColor: "LightYellow",
            }}
            value={enrollCode}
            onChange={(event) =>
              this.setState({ enrollCode: event.target.value })
            }
          />
          <Button type="primary" onClick={() => this.api_list_items()}>
            <i className="fas fa-search element-hidden"></i>
            <span style={{ marginLeft: "4px" }}>查詢</span>
          </Button>{" "}
          <Button type="primary" onClick={() => this.handle_data_download()}>
            <i className="fas fa-cloud-download-alt"></i>
            <span style={{ marginLeft: "4px" }}> 下載所有報名者清單</span>
          </Button>
        </div>
        {loading ? (
          <div className="container">
            <div className="text-center">
              <button
                className="btn btn-light text-dark"
                type="button"
                disabled
              >
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>{" "}
                查詢中 ......
              </button>
            </div>
          </div>
        ) : (
          <>
            {" "}
            <div className="container">
              <div className="row">
                {items.map((item, index) => {
                  return (
                    <div
                      className="col-md-4"
                      key={index}
                      style={{ marginBottom: "6px" }}
                    >
                      <div className="titleMame">
                        {/* <button
                          type="button"
                          className="btn btn-warning btn-sm"
                          onClick={() =>
                            this.handle_show_ui_modal("VIEW", item)
                          }
                        >
                          <i className="fa fa-upload"></i>
                          <span style={{ marginLeft: "4px" }}>轉PDF</span>
                        </button> */}
                        <button
                          type="button"
                          className="btn btn-warning btn-sm"
                          style={{ margin: "2px" }}
                          onClick={() =>
                            this.handle_show_ui_modal("PRINT", item)
                          }
                        >
                          <i className="fa fa-upload"></i>
                          <span style={{ marginLeft: "4px" }}>轉匯出</span>
                        </button>
                        <a
                          href={DEFAULT_IMAGE_URL + item.AttachedfileC}
                          download="授權書"
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-info btn-sm"
                        >
                          {" "}
                          <i
                            className="fa fa-download"
                            style={{ marginRight: "4px" }}
                          ></i>{" "}
                          授權書
                        </a>
                        <span style={{ fontSize: "14px", marginLeft: "4px" }}>
                          {item.EnrollName}({item.EnrollCode})
                        </span>
                      </div>
                      <div className="thumbnail colstyle" key={index}>
                        <div className="caption">
                          <Collapse accordion>
                            <Panel header="角色名稱" key="1">
                              <p>{item.Title}</p>
                            </Panel>
                            <Panel header="創作理念" key="2">
                              <p>{item.Description}</p>
                            </Panel>
                            <Panel header="團隊成員" key="3">
                              <p>{item.Teams}</p>
                            </Panel>
                            <Panel header="聯絡資訊" key="4">
                              <table width={"100%"}>
                                <tr style={{ backgroundColor: "white" }}>
                                  <td>
                                    <i
                                      className="fa fa-user-circle"
                                      style={{ marginRight: "4px" }}
                                    ></i>
                                    {item.ContactPerson}
                                    <br />
                                    <i
                                      className="fa fa-phone"
                                      style={{ marginRight: "4px" }}
                                    ></i>
                                    {item.ContactPhone}
                                    <br />
                                    <i
                                      className="fa fa-envelope-open"
                                      style={{ marginRight: "4px" }}
                                    ></i>
                                    {item.ContactEmail}
                                  </td>
                                </tr>
                              </table>
                            </Panel>
                          </Collapse>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <Image
                            width={"174px"}
                            height={"126px"}
                            src={DEFAULT_IMAGE_URL + item.AttachedfileA}
                          />
                          <Image
                            width={"174px"}
                            height={"126px"}
                            src={DEFAULT_IMAGE_URL + item.AttachedfileB}
                          />
                          <h6
                            style={{
                              color: "gray",
                              marginTop: "2px",
                              fontSize: "0.6em",
                            }}
                          >
                            (點圖可放大)
                          </h6>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <Modal
              destroyOnClose={true}
              visible={isPdfWorkModal}
              onOk={() => {
                this.setState({ isPdfWorkModal: false });
              }}
              okText={"關閉"}
              onCancel={() => {
                this.setState({ isPdfWorkModal: false });
              }}
              cancelButtonProps={{ style: { display: "none" } }}
            >
              <OutFileModal item={item} />
            </Modal>
            <Modal
              destroyOnClose={true}
              visible={isPrintWorkModal}
              onOk={() => {
                this.setState({ isPrintWorkModal: false });
              }}
              okText={"關閉"}
              onCancel={() => {
                this.setState({ isPrintWorkModal: false });
              }}
              cancelButtonProps={{ style: { display: "none" } }}
            >
              <PrintFileModal item={item} />
            </Modal>
            <BackTop>
              <div className="goTop">UP</div>
            </BackTop>
          </>
        )}
      </>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(JuryAllWorksList);
